export default async function getArticleList(
  $http,
  path,
  title,
  type,
  pagenum,
  pagesize
) {
  return await $http.get(path, {
    params: {
      title: title,
      type: type,
      pagenum: pagenum,
      pagesize: pagesize
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/getArticleList.js